import { Layout, Skeleton } from "../../components/ui";
import { useDeleteHomework, useGetHomeworkById } from "../../query/homeworkQuery";
import { useNavigate, useParams } from "react-router-dom";
import swal from "../../utils/swal";
import HomeworkProfile from "./HomeworkProfile";

function HomeworkDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, data: homework } = useGetHomeworkById(id);
  const { mutate: deleteHomework } = useDeleteHomework();

  const handleDelete = () => {
    swal({
      title: "Are you sure?",
      text: "Do you want to delete this homework entry?",
      icon: "warning",
      buttons: ["No, cancel it!", "Yes, I am sure!"],
      dangerMode: true,
    }).then((isConfirm) => {
      if (!isConfirm) return;
      deleteHomework(id, {
        onSuccess: () => {
          swal("Success", "Homework deleted successfully", "success");
          navigate("/homework");
        },
        onError: (error) => {
          swal("Cannot delete", error?.message || "Failed to delete homework", "error");
        },
      });
    });
  };

  return (
    <Layout className="configuration">
      <div className="boxDetails" style={{ background: "transparent", padding: 0, boxShadow: "none" }}>
        {isLoading && (
          <div style={{ display: "flex", justifyContent: "center", padding: "40px 0" }}>
            <Skeleton active paragraph={{ rows: 10 }} />
          </div>
        )}

        {!isLoading && homework && <HomeworkProfile homework={homework} onDelete={handleDelete} />}
      </div>
    </Layout>
  );
}

export default HomeworkDetails;
